<template>
<div>
</div>
</template>

<script>
import { bus } from '../bus.js'
// import axios from 'axios'

export default {
  name: 'Intranet',

  data () {
    return {
      plasmids: []
    }
  },

  methods: {
  },

  created () {
//    var v = this

    this.$nextTick(function () {
      bus.$emit('switch-router', 'Members')
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
